import React from 'react';
import { cn } from '../../lib/utils';

/** Logo dell'app Vexel POS (usa l'icona ufficiale). */
export const Logo = ({ className = 'h-11 w-11', rounded = 'rounded-xl' }) => (
  <img
    src="/icons/icon-192.png"
    alt="Vexel POS"
    draggable={false}
    className={cn('object-cover select-none', rounded, className)}
  />
);
